import { FilterOption } from "../modules/filters/js/themes";
import { VideoItem } from "../modules/posters/js/posters";
const filterMenuItems: FilterOption[] = [
  {
    id: "all",
    buttonId: "filterAllBtn",
    label: "ALL THEMES",
    className: "all",
  },
  {
    id: "sounds",
    buttonId: "filterSoundsBtn",
    label: "SOUNDS",
    className: "sounds",
  },
  {
    id: "evacuation",
    buttonId: "filterEvacuationBtn",
    label: "EVACUATION",
    className: "evacuation",
  },
  {
    id: "shelters",
    buttonId: "filterSheltersBtn",
    label: "SHELTERS",
    className: "shelters",
  },
  {
    id: "assistance",
    buttonId: "filterAssistanceBtn",
    label: "ASSISTANCE",
    className: "assistance",
  },
  {
    id: "communication",
    buttonId: "filterCommunicationBtn",
    label: "COMMUNICATION",
    className: "communication",
  },
  {
    id: "ash",
    buttonId: "filterAshBtn",
    label: "ASH",
    className: "ash",
  },
  {
    id: "spiritualism",
    buttonId: "filterSpiritualismBtn",
    label: "SPIRITUALISM",
    className: "spiritualism",
  },
  {
    id: "movingon",
    buttonId: "filterMovingOnBtn",
    label: "MOVING ON",
    className: "movingon",
  },
];

const peopleObj: VideoItem[] = [
  {
    id: "hardi",
    name: "Hardi",
    description: "The best fertiliser",
    category: "Village Residents",
    themes: "evacuation, shelters, ash, moving on",
    video_url: "https://www.youtube.com/watch?v=kNMDM8xmD2I",
    video_id: "kNMDM8xmD2I",
    duration: "3:05",
    connectedPeople: [
      { id: "woyo", lineId: "l1_5", theme: "ash" },
      { id: "poniran", lineId: "l1_6", theme: "evacuation" },
      { id: "purdiwiyono", lineId: "l1_7", theme: "shelters" },
      { id: "wignyo", lineId: "l1_8", theme: "movingon" },
      { id: "budhi", lineId: "l1_9", theme: "evacuation" },
      { id: "inna", lineId: "l1_10", theme: "ash" },
      { id: "ayu", lineId: "l1_13", theme: "ash" },
    ],
    themeIds: ["evacuation", "shelters", "ash", "movingon"],
  },
  {
    id: "wanti",
    name: "Wanti",
    description: "Five people. One motorbike",
    category: "Village Residents",
    themes: "evacuation, shelters",
    video_url: "https://www.youtube.com/watch?v=muEiFgIVsWY",
    video_id: "muEiFgIVsWY",
    duration: "3:03",
    themeIds: ["evacuation", "shelters"],
    connectedPeople: [
      { id: "yoga", lineId: "l2_3", theme: "evacuation" },
      { id: "tjipto", lineId: "l2_4", theme: "evacuation" },
      { id: "wignyo", lineId: "l2_8", theme: "shelters" },
      { id: "yani", lineId: "l2_12", theme: "shelters" },
      { id: "riyanto", lineId: "l2_16", theme: "evacuation" },
    ],
  },
  {
    id: "yoga",
    name: "Yoga",
    description: "Separated by ash",
    category: "Village Residents",
    themes: "sounds, evacuation, ash",
    video_url: "https://www.youtube.com/watch?v=eG7LKAURAwQ",
    video_id: "eG7LKAURAwQ",
    duration: "2:41",
    themeIds: ["sounds", "evacuation", "ash"],
    connectedPeople: [
      { id: "wanti", lineId: "l2_3", theme: "evacuation" },
      { id: "tjipto", lineId: "l3_4", theme: "evacuation" },
      { id: "woyo", lineId: "l3_5", theme: "ash" },
      { id: "poniran", lineId: "l3_6", theme: "sounds" },
      { id: "yani", lineId: "l3_12", theme: "evacuation" },
      { id: "ayu", lineId: "l3_13", theme: "evacuation" },
      { id: "heru", lineId: "l3_15", theme: "sounds" },
    ],
  },
  {
    id: "tjipto",
    name: "Tjipto",
    description: "What can happen in one minute",
    category: "Village Residents",
    themes: "sounds, evacuation",
    video_url: "https://www.youtube.com/watch?v=mHBaIy6gvCo",
    video_id: "mHBaIy6gvCo",
    duration: "2:57",
    themeIds: ["sounds", "evacuation"],
    connectedPeople: [
      { id: "wanti", lineId: "l2_4", theme: "evacuation" },
      { id: "yoga", lineId: "l3_4", theme: "evacuation" },
      { id: "woyo", lineId: "l4_5", theme: "sounds" },
      { id: "poniran", lineId: "l4_6", theme: "sounds" },
      { id: "agung", lineId: "l4_14", theme: "evacuation" },
      { id: "heru", lineId: "l4_15", theme: "evacuation" },
    ],
  },
  {
    id: "woyo",
    name: "Woyo",
    description: "Gift or curse? Living in the shadow of 3 volcanoes",
    category: "Village Residents",
    themes: "sounds, evacuation, ash, spiritualism",
    video_url: "https://www.youtube.com/watch?v=RKvAmt8L8lo",
    video_id: "RKvAmt8L8lo",
    duration: "4:32",
    themeIds: ["sounds", "evacuation", "ash", "spiritualism"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_5", theme: "ash" },
      { id: "yoga", lineId: "l3_5", theme: "ash" },
      { id: "tjipto", lineId: "l4_5", theme: "sounds" },
      { id: "poniran", lineId: "l5_6", theme: "evacuation" },
      { id: "wignyo", lineId: "l5_8", theme: "spiritualism" },
      { id: "riyanto", lineId: "l5_16", theme: "ash" },
    ],
  },
  {
    id: "poniran",
    name: "Poniran",
    description: "Rumbling and rattling by the Gendol river",
    category: "Village Residents",
    themes: "sounds, evacuation",
    video_url: "https://www.youtube.com/watch?v=ZAF5yf-P0QI",
    video_id: "ZAF5yf-P0QI",
    duration: "2:40",
    themeIds: ["sounds", "evacuation"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_6", theme: "evacuation" },
      { id: "yoga", lineId: "l3_6", theme: "sounds" },
      { id: "tjipto", lineId: "l4_6", theme: "sounds" },
      { id: "woyo", lineId: "l5_6", theme: "evacuation" },
      { id: "purdiwiyono", lineId: "l6_7", theme: "evacuation" },
      { id: "heru", lineId: "l6_15", theme: "evacuation" },
    ],
  },
  {
    id: "purdiwiyono",
    name: "Purdiwiyono",
    description: "Where his house once stood. Stories by the campfire",
    category: "Village Residents",
    themes: "evacuation, shelters, assistance",
    video_url: "https://www.youtube.com/watch?v=_D1gV88wYFk",
    video_id: "_D1gV88wYFk",
    duration: "3:48",
    themeIds: ["evacuation", "shelters", "assistance"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_7", theme: "shelters" },
      { id: "poniran", lineId: "l6_7", theme: "evacuation" },
      { id: "wignyo", lineId: "l7_8", theme: "shelters" },
      { id: "inna", lineId: "l7_10", theme: "assistance" },
    ],
  },
  {
    id: "wignyo",
    name: "Wignyo",
    description: "The Gatekeeper and life in the shelter",
    category: "Village Residents",
    themes: "shelters, spiritualism, moving on",
    video_url: "https://www.youtube.com/watch?v=IP4DCfrukIo",
    video_id: "IP4DCfrukIo",
    duration: "2:54",
    themeIds: ["shelters", "spiritualism", "movingon"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_8", theme: "movingon" },
      { id: "wanti", lineId: "l2_8", theme: "shelters" },
      { id: "woyo", lineId: "l5_8", theme: "spiritualism" },
      { id: "purdiwiyono", lineId: "l7_8", theme: "shelters" },
      { id: "agung", lineId: "l8_14", theme: "spiritualism" },
      { id: "dewi", lineId: "l8_21", theme: "movingon" },
    ],
  },
  {
    id: "budhi",
    name: "Budhi",
    description: "Talking tweets: the role of social media in the emergency",
    category: "Volunteers and Coordinators",
    themes: "evacuation, assistance, communication",
    video_url: "https://www.youtube.com/watch?v=-ukYWFBk8v4",
    video_id: "-ukYWFBk8v4",
    duration: "2:53",
    themeIds: ["evacuation", "assistance", "communication"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_9", theme: "evacuation" },
      { id: "inna", lineId: "l9_10", theme: "communication" },
      { id: "ayu", lineId: "l9_13", theme: "assistance" },
      { id: "heru", lineId: "l9_15", theme: "communication" },
      { id: "riyanto", lineId: "l9_16", theme: "assistance" },
      { id: "wahyu", lineId: "l9_17", theme: "assistance" },
    ],
  },
  {
    id: "inna",
    name: "Inna",
    description: "A pair of swimming goggles and a little faith",
    category: "Volunteers and Coordinators",
    themes: "evacuation, assistance, communication, ash",
    video_url: "https://www.youtube.com/watch?v=lClLu10EkWA",
    video_id: "lClLu10EkWA",
    duration: "4:06",
    themeIds: ["evacuation", "assistance", "communication", "ash"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_10", theme: "ash" },
      { id: "purdiwiyono", lineId: "l7_10", theme: "assistance" },
      { id: "budhi", lineId: "l9_10", theme: "communication" },
      { id: "uki", lineId: "l10_11", theme: "assistance" },
      { id: "yani", lineId: "l10_12", theme: "assistance" },
      { id: "ayu", lineId: "l10_13", theme: "evacuation" },
      { id: "wahyu", lineId: "l10_17", theme: "ash" },
      { id: "endah", lineId: "l10_18", theme: "ash" },
    ],
  },
  {
    id: "uki",
    name: "Uki",
    description: "Volcanoes, eruptions, and .... drag shows?",
    category: "Volunteers and Coordinators",
    themes: "shelters, assistance",
    video_url: "https://www.youtube.com/watch?v=zVbQ5owaWLo",
    video_id: "zVbQ5owaWLo",
    duration: "4:00",
    themeIds: ["shelters", "assistance"],
    connectedPeople: [
      { id: "inna", lineId: "l10_11", theme: "assistance" },
      { id: "yani", lineId: "l11_12", theme: "shelters" },
      { id: "moki", lineId: "l11_20", theme: "assistance" },
    ],
  },
  {
    id: "yani",
    name: "Yani",
    description: "The birth of the extraordinary",
    category: "Volunteers and Coordinators",
    themes: "evacuation, shelters, assistance, spiritualism",
    video_url: "https://www.youtube.com/watch?v=0eB34p9dfbs",
    video_id: "0eB34p9dfbs",
    duration: "3:41",
    themeIds: ["evacuation", "shelters", "assistance", "spiritualism"],
    connectedPeople: [
      { id: "wanti", lineId: "l2_12", theme: "shelters" },
      { id: "yoga", lineId: "l3_12", theme: "evacuation" },
      { id: "inna", lineId: "l10_12", theme: "assistance" },
      { id: "uki", lineId: "l11_12", theme: "shelters" },
      { id: "agung", lineId: "l12_14", theme: "spiritualism" },
      { id: "sinta", lineId: "l12_19", theme: "shelters" },
    ],
  },
  {
    id: "ayu",
    name: "Ayu",
    description: "Should I stay or should I go?",
    category: "Volunteers and Coordinators",
    themes: "evacuation, assistance, communication, ash",
    video_url: "https://www.youtube.com/watch?v=gIom3KUAk30",
    video_id: "gIom3KUAk30",
    duration: "3:12",
    themeIds: ["evacuation", "assistance", "communication", "ash"],
    connectedPeople: [
      { id: "hardi", lineId: "l1_13", theme: "ash" },
      { id: "yoga", lineId: "l3_13", theme: "evacuation" },
      { id: "budhi", lineId: "l9_13", theme: "assistance" },
      { id: "inna", lineId: "l10_13", theme: "evacuation" },
      { id: "agung", lineId: "l13_14", theme: "assistance" },
      { id: "heru", lineId: "l13_15", theme: "communication" },
      { id: "endah", lineId: "l13_18", theme: "evacuation" },
      { id: "sinta", lineId: "l13_19", theme: "communication" },
    ],
  },
  {
    id: "agung",
    name: "Agung",
    description: "What could have been",
    category: "Volunteers and Coordinators",
    themes: "evacuation, assistance, spiritualism",
    video_url: "https://www.youtube.com/watch?v=yk4My48FSls",
    video_id: "yk4My48FSls",
    duration: "3:57",
    themeIds: ["evacuation", "assistance", "spiritualism"],
    connectedPeople: [
      { id: "tjipto", lineId: "l4_14", theme: "evacuation" },
      { id: "wignyo", lineId: "l8_14", theme: "spiritualism" },
      { id: "yani", lineId: "l12_14", theme: "spiritualism" },
      { id: "ayu", lineId: "l13_14", theme: "assistance" },
      { id: "heru", lineId: "l14_15", theme: "evacuation" },
    ],
  },
  {
    id: "heru",
    name: "Heru",
    description: "Reading the signs: views from the observation post",
    category: "Volunteers and Coordinators",
    themes: "sounds, evacuation, communication, ash",
    video_url: "https://www.youtube.com/watch?v=nsLwK18QTkQ",
    video_id: "nsLwK18QTkQ",
    duration: "3:10",
    themeIds: ["sounds", "evacuation", "communication", "ash"],
    connectedPeople: [
      { id: "yoga", lineId: "l3_15", theme: "sounds" },
      { id: "tjipto", lineId: "l4_15", theme: "evacuation" },
      { id: "poniran", lineId: "l6_15", theme: "evacuation" },
      { id: "budhi", lineId: "l9_15", theme: "communication" },
      { id: "ayu", lineId: "l13_15", theme: "communication" },
      { id: "agung", lineId: "l14_15", theme: "evacuation" },
      { id: "riyanto", lineId: "l15_16", theme: "evacuation" },
      { id: "dewi", lineId: "l15_21", theme: "ash" },
    ],
  },
  {
    id: "riyanto",
    name: "Riyanto",
    description: "A model for evacuation",
    category: "Volunteers and Coordinators",
    themes: "evacuation, assistance, ash",
    video_url: "https://www.youtube.com/watch?v=3jU71ERkuKI",
    video_id: "3jU71ERkuKI",
    duration: "3:50",
    themeIds: ["evacuation", "assistance", "ash"],
    connectedPeople: [
      { id: "wanti", lineId: "l2_16", theme: "evacuation" },
      { id: "woyo", lineId: "l5_16", theme: "ash" },
      { id: "budhi", lineId: "l9_16", theme: "assistance" },
      { id: "heru", lineId: "l15_16", theme: "evacuation" },
    ],
  },
  {
    id: "wahyu",
    name: "Wahyu",
    description: "Food that sustains and a city that never stops",
    category: "Wider Community",
    themes: "assistance, ash",
    video_url: "https://www.youtube.com/watch?v=KRRmFRCvY30",
    video_id: "KRRmFRCvY30",
    duration: "3:43",
    themeIds: ["assistance", "ash"],
    connectedPeople: [
      { id: "budhi", lineId: "l9_17", theme: "assistance" },
      { id: "inna", lineId: "l10_17", theme: "ash" },
      { id: "endah", lineId: "l17_18", theme: "ash" },
      { id: "moki", lineId: "l17_20", theme: "assistance" },
      { id: "dewi", lineId: "l17_21", theme: "ash" },
    ],
  },
  {
    id: "endah",
    name: "Endah",
    description: "Keep masked and carry on",
    category: "Wider Community",
    themes: "evacuation, ash",
    video_url: "https://www.youtube.com/watch?v=hEFkidU8PzY",
    video_id: "hEFkidU8PzY",
    duration: "3:29",
    themeIds: ["evacuation", "ash"],
    connectedPeople: [
      { id: "inna", lineId: "l10_18", theme: "ash" },
      { id: "ayu", lineId: "l13_18", theme: "evacuation" },
      { id: "wahyu", lineId: "l17_18", theme: "ash" },
      { id: "sinta", lineId: "l18_19", theme: "ash" },
      { id: "dewi", lineId: "l18_21", theme: "ash" },
    ],
  },
  {
    id: "sinta",
    name: "Sinta",
    description: "School's out",
    category: "Wider Community",
    themes: "shelters, communication, ash",
    video_url: "https://www.youtube.com/watch?v=JN4OAQo0HXw",
    video_id: "JN4OAQo0HXw",
    duration: "2:46",
    themeIds: ["shelters", "communication", "ash"],
    connectedPeople: [
      { id: "yani", lineId: "l12_19", theme: "shelters" },
      { id: "ayu", lineId: "l13_19", theme: "communication" },
      { id: "endah", lineId: "l18_19", theme: "ash" },
      { id: "moki", lineId: "l19_20", theme: "ash" },
      { id: "dewi", lineId: "l19_21", theme: "ash" },
    ],
  },
  {
    id: "moki",
    name: "Moki",
    description: "The music scene and more",
    category: "Wider Community",
    themes: "assistance, ash",
    video_url: "https://www.youtube.com/watch?v=2RYceEnp1-8",
    video_id: "2RYceEnp1-8",
    duration: "3:23",
    themeIds: ["assistance", "ash"],
    connectedPeople: [
      { id: "uki", lineId: "l11_20", theme: "assistance" },
      { id: "wahyu", lineId: "l17_20", theme: "assistance" },
      { id: "sinta", lineId: "l19_20", theme: "ash" },
      { id: "dewi", lineId: "l20_21", theme: "ash" },
    ],
  },
  {
    id: "dewi",
    name: "Dewi",
    description: "The business of batik and the new tourist",
    category: "Wider Community",
    themes: "ash, moving on",
    video_url: "https://www.youtube.com/watch?v=xKYgcjJm_B0",
    video_id: "xKYgcjJm_B0",
    duration: "3:22",
    themeIds: ["ash", "movingon"],
    connectedPeople: [
      { id: "wignyo", lineId: "l8_21", theme: "movingon" },
      { id: "heru", lineId: "l15_21", theme: "ash" },
      { id: "wahyu", lineId: "l17_21", theme: "ash" },
      { id: "endah", lineId: "l18_21", theme: "ash" },
      { id: "sinta", lineId: "l19_21", theme: "ash" },
      { id: "moki", lineId: "l20_21", theme: "ash" },
    ],
  },
];

export { filterMenuItems, peopleObj };
